import { TableBody, TableCell, TableRow } from '@mui/material';
import React from 'react';

import Loading from 'commons/Loading';

import CertificateRow from './components/CertificateRow';
import NoDataRow from './components/NoDataRow';
import useStyles from './styles';

const ManageCertificateTableBody = ({
  isPending,
  listCertificate,
  page,
  pageSize,
  highlightCertificateCode,
}) => {
  const classes = useStyles();

  if (isPending) {
    return (
      <TableBody>
        <TableRow>
          <TableCell
            colSpan={8}
            className={classes.loadingCell}
          >
            <Loading loadingStyle={classes.loading} />
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  if (!listCertificate || listCertificate.length === 0) {
    return (
      <TableBody>
        <NoDataRow colSpan={8} />
      </TableBody>
    );
  }

  return (
    <TableBody>
      {(listCertificate || []).map((certificate, index) => (
        <CertificateRow
          key={index}
          index={index}
          certificate={certificate}
          page={page}
          pageSize={pageSize}
          highlightCertificateCode={highlightCertificateCode}
        />
      ))}
    </TableBody>
  );
};

export default ManageCertificateTableBody;
